import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { FormControlLabel, Switch } from '@material-ui/core'

function CamposCereal () {
  return (
    <>
      <Row>
        <Col md={6}>
          <Field
            name='nombreCorto'
            type='text'
            label='Nombre corto *'
            component={renderTextField}
            maxLength={8}
          />
        </Col>
        <Col md={6}>
          <Field
            name='nombreCereal'
            type='text'
            label='Nombre cereal *'
            component={renderTextField}
          />
        </Col>
      </Row>
      <Row style={{ alignItems: 'center' }}>
        <Col md={3}>
          <Field
            name='humedad'
            type='text'
            label='Humedad *'
            component={renderTextField}
          />
        </Col>
        <Col md={3}>
          <Field
            name='pesoEspecifico'
            label='Peso especifico'
            component={renderTextField}
          />
        </Col>
        <Col md={3}>
          <Field
            name='codigoARCA'
            label='Codigo ARCA'
            component={renderTextField}
          />
        </Col>
        <Col md={3}>
          <Field
            name='habilitado'
            component={({ input }) => (
              <FormControlLabel
                control={
                  <Switch
                    color='primary'
                    name='habilitado'
                    checked={!!input.value}
                    onChange={(e) => input.onChange(e.target.checked)}
                  />
                }
                label='Habilitado'
              />
            )}
          />
        </Col>
        <Col md={12} style={{ textAlign: 'rigth', marginTop: '8px' }}>
          <p>(*) Campo requerido obligatorio</p>
        </Col>
      </Row>
    </>
  )
}

export default CamposCereal
